import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "Refund Payment", -1)
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Check")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("small", null, "Issuing a refund will change the payment amount in order to reverse the payment and restore the previous balance.", -1)
const _hoisted_6 = { class: "form-field" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "customAmount" }, "Amount to refund", -1)
const _hoisted_8 = ["max"]
const _hoisted_9 = { class: "form-field" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", null, "Refund Method", -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<option value=\"credit_card\">Credit Card</option><option value=\"ach\">Ach</option><option value=\"cash\">Cash</option><option value=\"check\">Check</option><option value=\"other\">Other</option>", 5)
const _hoisted_16 = [
  _hoisted_11
]
const _hoisted_17 = { class: "form-field" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Reason", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn",
  type: "submit"
}, "Update Transaction", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" Cancel ")

import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import { useRouter } from "vue-router";


export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: Number,
    required: true,
  },
  transactionId: {
    type: Number,
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const transaction = ref();
const errors = ref("");

const formFields = ref({
  amount: ref(""),
  creator_id: ref(""),
  reason: ref(""),
  refund_method: ref("credit_card"),
  transaction_id: ref(props.transactionId),
});
async function submitForm() {
  const json = JSON.parse(JSON.stringify(formFields.value));

  formErrors.value = {};
  formSubmitting.value = true;
  let url = `refunds/?facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    router.push({
      name: "customer_detail_ess",
      params: {
        id: props.customerId,
        facilityId: props.facilityId,
      },
    });
  } else if (responseData.status === 400) {
    formErrors.value["server_error"] = [responseData.body];
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function getTransaction() {
  errors.value = "";
  const response = await api({
    url: `transactions/?id=${props.transactionId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    transaction.value = response.body;
    formFields.value.amount = transaction.value.total;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getTransaction();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _hoisted_1,
    (transaction.value)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          class: "large-width-centered",
          onSubmit: _withModifiers(submitForm, ["prevent"])
        }, [
          _createElementVNode("p", _hoisted_3, [
            _createTextVNode(_toDisplayString(__props.customerName) + " paid $" + _toDisplayString(transaction.value.total) + " via ", 1),
            (transaction.value.check)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_4
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(transaction.value.account_summary), 1)
          ]),
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formFields.value.amount) = $event)),
              type: "decimal",
              required: "",
              max: transaction.value.total
            }, null, 8, _hoisted_8), [
              [_vModelText, formFields.value.amount]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _withDirectives(_createElementVNode("select", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formFields.value.refund_method) = $event)),
              class: "form-select",
              required: ""
            }, _hoisted_16, 512), [
              [_vModelSelect, formFields.value.refund_method]
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formFields.value.reason) = $event)),
              required: "",
              type: "text"
            }, null, 512), [
              [_vModelText, formFields.value.reason]
            ])
          ]),
          _hoisted_19,
          _createVNode(_component_RouterLink, {
            to: {
        name: 'customer_detail_ess',
        params: { id: __props.customerId, facilityId: __props.facilityId },
      },
            class: "btn btn-text"
          }, {
            default: _withCtx(() => [
              _hoisted_20
            ]),
            _: 1
          }, 8, ["to"])
        ], 40, _hoisted_2))
      : _createCommentVNode("", true),
    (formErrors.value.server_error !== undefined)
      ? (_openBlock(), _createBlock(_component_BaseAlert, {
          key: 1,
          variant: "danger",
          class: "js-form-error",
          dismissible: "",
          onDismissed: _cache[3] || (_cache[3] = ($event: any) => (formErrors.value = {}))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})